import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { ConnectStores } from "lib/core/store"
import { LEARN } from "path/constants"

const PathViewAsControl = function (props) {
  const { showViewAs, viewAsLearner, ...rest } = props

  if (!showViewAs) {
    return null
  }

  return (
    <Tooltip
      {...Object.assign(
        { className: "PathViewAsControl", title: "View as a learner" },
        rest
      )}
    >
      <Button
        {...Object.assign({ styleType: "blank", inverted: true }, rest, {
          onClick: viewAsLearner
        })}
      >
        <Pathicon icon="eye" />
      </Button>
    </Tooltip>
  )
}

PathViewAsControl.displayName = "PathViewAsControl"

const mapStateToProps = function (state, ownProps) {
  const { resource, section } = state.resourceStore.state
  const { viewAsLearner } = state.pathStore.action
  const { permissions } = state.resourceStore.request
  const { mode } = state.pathStore.state

  const showViewAs =
    resource != null &&
    mode > LEARN &&
    section === "path" &&
    __guard__(permissions(), (x) => x.can_edit_path)

  return _.assign(
    {},
    {
      showViewAs,
      viewAsLearner
    },
    ownProps
  )
}

const stores = [
  { store: "resource", watch: ["resource", "offering", "section"] },
  { store: "path", watch: ["mode"] }
]

export default ConnectStores(PathViewAsControl, stores, {}, mapStateToProps)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
